import { calculateCTRValue } from "./creativesPerformanceTable";

export const CTR_PERFORMANCE = {
  GOOD: 0.6,
  BAD: 0.42
};

export const isMetricPerformanceGood = ({ inlineClicks, impressions }) =>
  calculateCTRValue({ inlineClicks, impressions }) >= CTR_PERFORMANCE.GOOD;

export const isMetricPerformanceAverage = ({ inlineClicks, impressions }) =>
  calculateCTRValue({ inlineClicks, impressions }) < CTR_PERFORMANCE.GOOD &&
  calculateCTRValue({ inlineClicks, impressions }) > CTR_PERFORMANCE.BAD;

export const isMetricPerformanceBad = ({ inlineClicks, impressions }) =>
  calculateCTRValue({ inlineClicks, impressions }) <= CTR_PERFORMANCE.BAD;
